(function () {
  "use strict";

  document.addEventListener(
    "input",
    function (event) {
      var target = event.target;

      if (!(target instanceof HTMLInputElement)) {
        return;
      }

      /*
       * 通常名入れ
       * 半角英字のみ
       * 大文字・小文字は変更しない
       * 最大11文字
       */
      if (
        target.matches(".input_firstname input") ||
        target.matches(".input_familyname input")
      ) {
        target.value = target.value
          .replace(/[^A-Za-z]/g, "")
          .slice(0, 11);

        return;
      }

      /*
       * パーソナルロゴ
       *
       * 半角英字のみ
       * 最大11文字
       * 先頭文字：大文字
       * 2文字目以降：小文字
       * 1〜2文字の場合：エラー表示
       */
      if (
        target.matches('input[name="personal_logo"]') ||
        target.matches('input[data-name="personal_logo"]')
      ) {
        var value = target.value
          .replace(/[^A-Za-z]/g, "")
          .slice(0, 11);

        if (value.length > 0) {
          value =
            value.charAt(0).toUpperCase() +
            value.slice(1).toLowerCase();
        }

        target.value = value;

        /*
         * エラー表示用の要素を取得
         */
        var error = target.parentElement.querySelector(
          ".personal-logo-error"
        );

        /*
         * エラー表示要素がなければ作成
         */
        if (!error) {
          error = document.createElement("div");
          error.className = "personal-logo-error";
          error.style.color = "red";
          error.style.marginTop = "5px";

          target.parentElement.appendChild(error);
        }

        /*
         * 1〜2文字ならエラー表示
         * 3文字以上ならエラーを消す
         */
        if (value.length > 0 && value.length < 3) {
          error.textContent =
            "3文字以上入力してください。";
        } else {
          error.textContent = "";
        }
      }
    },
    true
  );
})();